import http from './http';
import { expandRoles } from './roleHierarchy';

const CACHE_KEY = 'tr_menus';

export const listMenus = () => http.get('/menus').then((r) => r.data);
export const updateMenuStatus = (id, is_active) => http.put(`/menus/${id}`, { is_active }).then((r) => r.data);
export const updateMenuRoles = (id, roles) => http.put(`/menus/${id}/roles`, { roles }).then((r) => r.data);

export async function refreshMenuCache() {
  try {
    const menus = await listMenus();
    localStorage.setItem(CACHE_KEY, JSON.stringify(menus));
    return menus;
  } catch (err) {
    return getCachedMenus();
  }
}

export function getCachedMenus() {
  const raw = localStorage.getItem(CACHE_KEY);
  return raw ? JSON.parse(raw) : [];
}

export function clearMenuCache() {
  localStorage.removeItem(CACHE_KEY);
}

// Menu terlihat jika: aktif (toggle global dari Menu Management) DAN salah satu role
// user (termasuk role yang diwarisi lewat hierarki, mis. admin mewarisi petugas)
// termasuk dalam menus.roles. Superadmin selalu lolos pengecekan role (akses penuh),
// tapi tetap tunduk pada toggle is_active (itu saklar fitur, bukan soal izin).
export function isMenuVisible(kode, roles) {
  const menus = getCachedMenus();
  const menu = menus.find((m) => m.kode === kode);
  // Belum ada di cache (mis. baru login) -> anggap terlihat, biar tidak salah blokir.
  if (!menu) return true;
  if (!menu.is_active) return false;
  const effective = expandRoles(Array.isArray(roles) ? roles : [roles]);
  if (effective.includes('superadmin')) return true;
  return Array.isArray(menu.roles) ? effective.some((r) => menu.roles.includes(r)) : true;
}
